import React, { useEffect } from "react";
import { CardBody, Button, UncontrolledTooltip, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import classes from "@/styles/get-quotes/get-quotes-main.module.css";
import FreightItems from "./freight-items";
import { defaultShippingItems } from "@/utils/constants";
import useAlertBar from "@/hooks/useAlertBar";
import { routes } from "@/utils/routes";
import { useRouter } from "next/router";

type Props = {
  formSubmit: (data: any) => void;
  loading: boolean;
  blockRates: boolean;
  hideServices: () => void;
};

const validationSchema = yup.object({});

const itemSchema = yup.object().shape({
  description: yup.string().required("Description is required"),
  packagingTypeLTL: yup.string().required("Packaging Type is required"),
  weight: yup
    .number()
    .typeError("Weight must be a number")
    .positive("Weight must be a positive number")
    .required("Weight is required"),
});

const LTLFreightItemsForm = ({
  formSubmit,
  loading,
  hideServices,
  blockRates,
}: Props) => {
  const { openAlertBar } = useAlertBar();
  const router = useRouter();
  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      freightItems: defaultShippingItems,
      handlingUnit1: { qty: "", code: "" },
      handlingUnit2: { qty: "", code: "" },
      guestEmail: "",
      unitOfMeasurement: "METRIC",
    },
    resolver: yupResolver(validationSchema),
    criteriaMode: "all",
    shouldFocusError: true,
  });

  const onSubmit = async (data: any) => {
    try {
      const valSchema = yup.array().of(itemSchema);
      await valSchema.validate(data.freightItems, {
        abortEarly: false,
      });

      formSubmit(data);
    } catch (error: any) {
      console.log(error);

      openAlertBar(
        <ul>
          {error.errors.map((e: string, i: number) => (
            <li key={i}>{e}</li>
          ))}
        </ul>,
        false
      );
    }
  };

  useEffect(() => {
    hideServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch("freightItems"), watch("unitOfMeasurement")]);

  return (
    <>
      <CardBody>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <FreightItems
            reset={reset}
            errors={errors}
            watch={watch}
            control={control}
            register={register}
            setValue={setValue}
          />
          {blockRates ? (
            <div
              className={`d-flex justify-content-center gap-3 align-items-center mt-5`}
            >
              <div className="text-green">
                You have reached request limit,
                <strong> Please Sign Up to continue</strong>.
              </div>
              <Button
                className="btn-darkBlue"
                color="primary"
                onClick={() => router.push(routes.register)}
                style={{ color: "#fff" }}
              >
                SIGN UP NOW FOR FREE
              </Button>
            </div>
          ) : (
            <Button
              className={`btn-darkBlue text-uppercase fw-bold ${classes.btnSubmitFloat}`}
              type="submit"
              disabled={loading}
              id="getFreightRatesBtn"
            >
              Get Rates
              {loading && <Spinner size="sm" className="ms-3" />}
            </Button>
          )}
          <UncontrolledTooltip target="getFreightRatesBtn">
            For international shipments, you need to provide the declared value
            of items to get UPS rates.
          </UncontrolledTooltip>
        </form>
      </CardBody>
      {/* <div>
        <p>
          <i>
            <b>Note: </b>
            <br />
            Thanks for trusting us to arrange your LTL Freight shipment! Fill
            out the form above to get started. A ShipVista team member will
            follow up with you shortly.
            <br />
            This quote will be based on the information you provide. Actual
            charges will be determined by shipment characteristics and any
            additional service options applicable at the time of shipment.
          </i>
        </p>
      </div> */}
    </>
  );
};

export default LTLFreightItemsForm;
